'use client';

import * as DialogPrimitive from '@radix-ui/react-dialog';

export const DialogPrimitiveComponents = {
  Root: DialogPrimitive.Root,
  Portal: DialogPrimitive.Portal,
  Overlay: DialogPrimitive.Overlay,
  Trigger: DialogPrimitive.Trigger,
  Content: DialogPrimitive.Content,
  Close: DialogPrimitive.Close,
};
